$ = jQuery.noConflict();

$(() => {

	function calcPrice(el1, el2, elresult){
		var a = $(el1).val() ? $(el1).val() : 0;
		var b = $(el2).val() ? $(el2).val() : 0;

		// a = a.replace(",", ".");
		// b = b.replace(",", ".");

		var aString = String(a);
		var bString = String(b);

		aString = aString.replace(',', '.');
		bString = bString.replace(',', '.');

		a = parseFloat(aString);
		b =	parseFloat(bString);

		if(isNaN(b) || isNaN(a)){
			$(elresult).val('Erro! Verificar valores informados acima.');
		}else{

			if(a && b) {
				var subresult = Math.round((a/b)*100)/100;

				//$(elresult).val(subresult);

				if(isNaN(subresult)){
					$(elresult).val('Erro! Verificar valores informados acima.');
				}else{
					
					subresult = subresult.toFixed(2);

					subresult = subresult.toString();

					subresult = subresult.replace(".", ",");


					$(elresult).val(subresult);
				
				}

			}
			else{

				$(elresult).val('');
			}
		}
	}


	$('#formcotacao').on('keyup change', '.target-price-number-a, .target-price-number-b', function() {
		calcPrice('.target-price-number-a', '.target-price-number-b', '.target-price-result');
	});

	$('#formcotacao').on('keyup change', '.resistence-price-number-a, .resistence-price-number-b', function() {
		calcPrice('.resistence-price-number-a', '.resistence-price-number-b', '.resistence-price-result');
	});

	$('#formlance').on('keyup change', '.target-price-number-a, .target-price-number-b', function() {
		calcPrice('.target-price-number-a', '.target-price-number-b', '.target-price-result');
	});

	$('#formlance').on('keyup change', '.target-price-new-number-a, .target-price-new-number-b', function() {
		calcPrice('.target-price-new-number-a', '.target-price-new-number-b', '.target-price-new-number-result');
	});

	$('#formlance').on('keyup change', '.resistence-price-number-a, .resistence-price-number-b', function() {
		calcPrice('.resistence-price-number-a', '.resistence-price-number-b', '.resistence-price-result');
	});

	$('#formproposta').on('keyup change', '.target-price-number-a, .target-price-number-b', function() {
		calcPrice('.target-price-number-a', '.target-price-number-b', '.target-price-result');
	});

	$('#formproposta').on('keyup change', '.resistence-price-number-a, .resistence-price-number-b', function() {
		calcPrice('.resistence-price-number-a', '.resistence-price-number-b', '.resistence-price-result');
	});

	$('#formcotacao').on('keyup change', '.target-price-new-number-a, .target-price-new-number-b', function() {
		calcPrice('.target-price-new-number-a', '.target-price-new-number-b', '.target-price-new-number-result');
	});

	$('#formaderenciaconvidado').on('keyup change', '.target-price-number-aa, .target-price-number-bb', function() {
		calcPrice('.target-price-number-aa', '.target-price-number-bb', '.target-price-resultt');
	});

	$('#formaderenciaconvidado').on('keyup change', '.resistence-price-number-aa, .resistence-price-number-bb', function() {
		calcPrice('.resistence-price-number-aa', '.resistence-price-number-bb', '.resistence-price-resultt');
	});

	function setChangeEffect(){

		$('.views-element-container').on('change', '.field_uf_cidade', function() {
			var valorCidade = $(this).val();
			$('input[name=cidade]').val(valorCidade);
		});

		$('.views-element-container').on('change', '.estado-definido', function() {
			$('input[name=cidade]').val('');
		});

	}

	setChangeEffect();

	$('.views-element-container').on("DOMNodeInserted", function() {
		setChangeEffect();
	});

	$('.agd-close-button').on("onclick click", function() {

		$('.agd-block-avisos').addClass('agd-block-avisos-hidden');

		var d = new Date();
  d.setTime(d.getTime() + (6*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie =  "nao-mostrar-aviso-pergunta=1;" + expires + ";path=/";

	});

});
